import React from 'react';
/**
 * interpret line breaks in strings as html <br />
 * @param {string} text - a plain text string, containing zero or more \n
 * @return the original text as html with line breaks as html <br />
 */

export function respectLineBreaks(text) {
  const regex = /(\n)/g;

  return text.split(regex).map((line, index) =>
    (line.match(regex) ? <br key={`break-${index}`} /> : <span key={`line-${index}`}>{line}</span>)
  );
}
